<template>
  <section>
    <section v-if="userCardList.length > 0" class="mt-10">
      <div v-for="card in userCardList" :key="card.id">
        <div
          class="rounded-2xl flex justify-between w-10/12 bg-smokeWhite mb-2 px-5 py-6"
        >
          <div class="flex items-center">
            <img
              :src="require(`@/assets/svg/Visa.svg`)"
              alt="Visa"
              class="bg-blue-darkest rounded-xl p-3"
            />
            <p class="ml-4 font-medium leading-5 text-sm">
              Visa ending with {{ String(card.card_number).slice(-4) }}
            </p>
            <p class="ml-14 font-medium leading-5 text-sm">
              Expiry {{ card.expiry_date.slice(0, 3) }}20{{
                card.expiry_date.slice(3)
              }}
            </p>
            <div class="flex ml-20" v-if="card && card.is_default === 1">
              <img
                :src="require(`@/assets/img/checked.png`)"
                class="w-6 h-6 rounded-full"
                alt="..."
              />
              <p class="ml-2 font-medium leading-5 text-sm">Default Card</p>
            </div>
          </div>
          <div class="flex">
            <!-- <select
              name="select"
              id="select"
              class="p-2 ring-1 bg-white ring-gray-400 focus:outline-none rounded-md appearance-none text-gray-light"
              @change="changeCardOption($event, card.id)"
            >
              <option value="choose">Options</option>
              <option value="edit">Edit</option>
              <option value="delete">Delete</option>
            </select> -->
            <button
              class="bg-white p-3 ring-1 rounded-lg ring-gray-400 w-20 focus:outline-none font-medium"
              @click="handleEditCardOption(card.id)"
            >
              Edit
            </button>
            <button
              class="bg-white p-3 ring-1 rounded-lg ring-gray-400 ml-4 w-20 focus:outline-none font-medium"
              @click="confirmDeleteCard(card.id)"
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </section>

    <NewModal
      :title="'Delete Card'"
      :headerClass="'text-2xl leading-8 tracking-tight font-semibold'"
      v-model="openConfirmDeleteCardModal"
    >
      <div class="flex flex-col justify-center pb-4">
        <p class="font-normal text-base">
          Are you sure you want to delete this card?
        </p>

        <div class="flex justify-between w-full mt-16">
          <button
            class="p-3 w-full font-medium bg-green-light text-white rounded-lg focus:outline-none"
            @click.prevent="handleDeleteCard(deleteCardId)"
          >
            Confirm
          </button>
          <button
            class="p-3 ml-4 font-medium w-full text-green-light ring-1 ring-green-light rounded-lg focus:outline-none"
            @click.prevent="openConfirmDeleteCardModal = false"
          >
            Cancel
          </button>
        </div>
      </div>
    </NewModal>

    <div
      class="rounded-2xl mt-14 flex justify-between w-10/12 bg-smokeWhite mb-2 px-5 py-6"
    >
      <img :src="require(`@/assets/svg/PayPal.svg`)" alt="Paypal" />
      <div
        class="text-white p-3 tracking-wide bg-gray-300 rounded-xl font-medium text-sm leading-4"
      >
        Coming Soon
      </div>
    </div>
    <div
      class="flex justify-between rounded-2xl w-10/12 px-6 py-6 mt-6 mb-96 bg-smokeWhite"
    >
      <div class="flex items-center">
        <div class="bg-black rounded-md">
          <img
            :src="require(`@/assets/svg/CreditCard.svg`)"
            class="p-3"
            alt="..."
          />
        </div>
        <div class="flex flex-col ml-5">
          <span class="font-semibold text-2xl">Payment methods</span>
          <span class="text-sm font-normal leading-6 tracking-tight"
            >You do not currently have any payment methods.</span
          >
        </div>
      </div>
      <div class="flex">
        <button
          class="text-white bg-green-light px-16 py-3 rounded-md font-semibold focus:outline-none mr-5"
          @click="openAddCreditCardModal = true"
        >
          Add Card
        </button>
        <!-- <button
          class="text-white bg-black px-16 py-3 rounded-md font-semibold focus:outline-none"
          @click="openPayPalModal = true"
        >
          Add PayPal
        </button> -->
      </div>
    </div>
    <NewModal
      :title="'Add Card'"
      :headerClass="'text-2xl leading-8 tracking-tight font-semibold'"
      v-model="openAddCreditCardModal"
    >
      <div class="mb-4">
        <p class="font-medium text-sm leading-5">Card Details</p>
        <input
          type="text"
          maxlength="25"
          placeholder="Name on the card"
          v-model="cardName"
          class="font-normal text-sm leading-5 text-gray-slate ring-1 ring-gray-400 w-full rounded-t-md py-2 px-3 mt-1 focus:outline-none"
        />
        <input
          type="text"
          maxlength="19"
          pattern="[0-9]*"
          placeholder="Card Number"
          v-model="cardNumber"
          class="font-normal text-sm leading-5 text-gray-slate ring-1 ring-gray-400 w-full py-2 px-3 focus:outline-none"
        />
        <input
          type="tel"
          name="expiry_date"
          placeholder="MM / YY"
          pattern="\d*"
          maxlength="7"
          @keyup="addSlash($event)"
          @keydown="removeSlash($event)"
          v-model="expiryDate"
          class="font-normal text-sm leading-5 text-gray-slate ring-1 ring-gray-400 w-1/2 rounded-bl-md py-2 px-3 focus:outline-none"
        />
        <input
          type="password"
          placeholder="CVV"
          pattern="\d*"
          maxlength="4"
          class="font-normal text-sm leading-5 text-gray-slate ring-1 ring-gray-400 w-1/2 rounded-br-md py-2 px-3 focus:outline-none"
        />
        <p class="pt-6 font-medium text-sm leading-5">Billing Address</p>
        <select
          name="select"
          id="select"
          class="font-normal text-sm leading-5 ring-1 rounded-t-md ring-gray-400 mt-2 w-full bg-white py-2 px-3 focus:outline-none"
          @change="selectCountry($event)"
        >
          <option value="none" selected disabled>Country</option>
          <option
            v-for="country in countryList"
            :key="country.id"
            :value="country.id"
          >
            {{ country.name }}
          </option>
        </select>
        <select
          name="select"
          id="select-state"
          class="font-normal text-sm leading-5 ring-1 ring-gray-400 w-1/2 bg-white py-2 px-3 focus:outline-none"
          @change="selectState($event)"
        >
          <option value="none" selected disabled>State</option>
          <option v-for="state in stateList" :key="state.id" :value="state.id">
            {{ state.name }}
          </option>
        </select>
        <select
          name="select"
          id="select-city"
          class="font-normal text-sm leading-5 ring-1 ring-gray-400 w-1/2 bg-white py-2 px-3 focus:outline-none"
          @change="selectCity($event)"
        >
          <option value="none" selected disabled>City</option>
          <option v-for="city in cityList" :key="city.id" :value="city.id">
            {{ city.name }}
          </option>
        </select>
        <input
          type="text"
          placeholder="Address"
          v-model="address"
          class="font-normal text-sm leading-5 text-gray-slate ring-1 ring-gray-400 w-full py-2 px-3 focus:outline-none"
        />
        <input
          type="text"
          placeholder="Postal code"
          v-model="postalCode"
          class="font-normal text-sm leading-5 text-gray-slate ring-1 ring-gray-400 w-full rounded-b-md py-2 px-3 focus:outline-none"
        />
        <div class="flex mt-6" v-if="!alreadyDefault">
          <input
            type="checkbox"
            v-model="saveAsDefaultCard"
            class="w-5 h-5 mr-2 focus:outline-none"
          />
          <p class="font-normal text-sm leading-5">
            Make this card as your default card
          </p>
        </div>
        <button
          class="text-white font-semibold bg-green-light py-2 w-full rounded-lg mt-6 focus:outline-none"
          @click="addCard"
        >
          Submit
        </button>
      </div>
    </NewModal>

    <NewModal
      :title="'Edit Card'"
      :headerClass="'text-2xl leading-8 tracking-tight font-semibold'"
      v-model="openEditCreditCardModal"
    >
      <div class="mb-4">
        <p class="font-medium text-sm leading-5">Card Details</p>
        <input
          type="text"
          maxlength="25"
          placeholder="Name on the card"
          v-model="editCardName"
          class="font-normal text-sm leading-5 text-gray-slate ring-1 ring-gray-400 w-full rounded-t-md py-2 px-3 mt-1 focus:outline-none"
        />
        <input
          type="text"
          readonly
          maxlength="19"
          pattern="[0-9]*"
          placeholder="Card Number"
          v-model="editCardNumber"
          class="font-normal text-sm leading-5 text-gray-slate ring-1 ring-gray-400 w-full py-2 px-3 focus:outline-none"
        />
        <input
          type="tel"
          placeholder="MM / YY"
          pattern="\d*"
          maxlength="7"
          @keyup="addSlash($event)"
          @keydown="removeSlash($event)"
          v-model="editExpiryDate"
          class="font-normal text-sm leading-5 text-gray-slate ring-1 ring-gray-400 w-1/2 rounded-bl-md py-2 px-3 focus:outline-none"
        />
        <input
          type="password"
          placeholder="CVV"
          pattern="\d*"
          maxlength="4"
          class="font-normal text-sm leading-5 text-gray-slate ring-1 ring-gray-400 w-1/2 rounded-br-md py-2 px-3 focus:outline-none"
        />
        <p class="pt-6 font-medium text-sm leading-5">Billing Address</p>
        <select
          name="select"
          id="select"
          class="font-normal text-sm leading-5 ring-1 rounded-t-md ring-gray-400 mt-2 w-full bg-white py-2 px-3 focus:outline-none"
          @change="selectCountry($event)"
        >
          <option :value="editCountry && editCountry.id" selected>
            {{ editCountry && editCountry.name }}
          </option>
          <option
            v-for="country in countryList"
            :key="country.id"
            :value="country.id"
          >
            {{ country.name }}
          </option>
        </select>
        <select
          name="select"
          id="select-state"
          class="font-normal text-sm leading-5 ring-1 ring-gray-400 w-1/2 bg-white py-2 px-3 focus:outline-none"
          @change="selectState($event)"
        >
          <option :value="editState && editState.id" selected>
            {{ editState && editState.name }}
          </option>
          <option v-for="state in stateList" :key="state.id" :value="state.id">
            {{ state.name }}
          </option>
        </select>
        <select
          name="select"
          id="select-city"
          class="font-normal text-sm leading-5 ring-1 ring-gray-400 w-1/2 bg-white py-2 px-3 focus:outline-none"
          @change="selectCity($event)"
        >
          <option :value="editCity && editCity.id" selected>
            {{ editCity && editCity.name }}
          </option>
          <option v-for="city in cityList" :key="city.id" :value="city.id">
            {{ city.name }}
          </option>
        </select>
        <input
          type="text"
          placeholder="Address"
          v-model="editAddress"
          class="font-normal text-sm leading-5 text-gray-slate ring-1 ring-gray-400 w-full py-2 px-3 focus:outline-none"
        />
        <input
          type="text"
          placeholder="Postal code"
          v-model="editPostalCode"
          class="font-normal text-sm leading-5 text-gray-slate ring-1 ring-gray-400 w-full rounded-b-md py-2 px-3 focus:outline-none"
        />
        <button
          class="text-white font-semibold bg-green-light py-2 w-full rounded-lg mt-10 focus:outline-none"
          @click="editCard(cardData[0].id)"
        >
          Submit
        </button>
      </div>
    </NewModal>
  </section>
</template>

<script>
import NewModal from "@/components/t-components/NewModal.vue";
import { mapGetters, mapActions } from "vuex";
import store from "@/store";

export default {
  name: "PaymentSettings",
  components: {
    NewModal,
  },
  data() {
    return {
      monthAndSlashRegex: /^\d\d \/ $/, // regex to match "MM / "
      monthRegex: /^\d\d$/, // regex to match "MM"
      alreadyDefault: false,
      cardName: null,
      // country: null,
      state: null,
      city: null,
      address: null,
      saveAsDefaultCard: false,
      openConfirmDeleteCardModal: false,
      openAddCreditCardModal: false,
      openEditCreditCardModal: false,
      openPayPalModal: false,
      deleteCardId: null,
      cardNumber: null,
      expiryDate: null,
      postalCode: null,
      country: null,
      // cardNumber: null,
      editCardName: null,
      editCardNumber: "**** **** **** ",
      editExpiryDate: null,
      editCountry: null,
      editState: null,
      editCity: null,
      editAddress: null,
      editPostalCode: null,
    };
  },
  watch: {
    cardNumber() {
      if (this.cardNumber) {
        let realNumber = this.cardNumber.replace(/-/gi, "");
        let dashedNumber = realNumber.match(/.{1,4}/g);
        this.cardNumber = dashedNumber.join("-");
      }
    },
  },
  computed: {
    ...mapGetters([
      "userCardList",
      "countryList",
      "stateList",
      "cityList",
      "cardData",
    ]),
  },
  methods: {
    ...mapActions([
      "addUserCard",
      "getUserCardList",
      "deleteUserCard",
      "getCountryList",
      "getStateList",
      "getCityList",
      "getCardDetails",
      "updateCardDetails",
    ]),

    formatCardNumber(value) {
      return value ? value.match(/.{1,4}/g).join(" ") : "";
    },

    addSlash(e) {
      var isMonthEntered = this.monthRegex.exec(e.target.value);
      if (e.key >= 0 && e.key <= 9 && isMonthEntered) {
        e.target.value = e.target.value + " / ";
      }
    },

    removeSlash(e) {
      var isMonthAndSlashEntered = this.monthAndSlashRegex.exec(e.target.value);
      if (e.key === "Backspace" && isMonthAndSlashEntered) {
        e.target.value = e.target.value.slice(0, -3);
      }
    },

    async selectCountry(event) {
      this.country = event.target.value;
      if (this.editCountry) this.editCountry = event.target.value;
      await this.getStateList(event.target.value);
    },

    async selectState(event) {
      this.state = event.target.value;
      if (this.editState) this.editState = event.target.value;
      await this.getCityList(event.target.value);
    },

    async selectCity(event) {
      this.city = event.target.value;
      if (this.editCity) this.editCity = event.target.value;
    },

    async handleEditCardOption(id) {
      this.openEditCreditCardModal = true;
      await this.getCardDetails(id);

      this.editCardName = this.cardData[0].name_on_card;
      this.editCardNumber += this.cardData[0].card_number;
      this.editExpiryDate = this.cardData[0].expiry_date;
      this.editCountry = this.countryList[this.cardData[0].country_code - 1];

      await this.getStateList(this.cardData[0].country_code);
      const stateIndex = this.stateList.findIndex((item) => {
        return item.id == this.cardData[0].state_code;
      });
      this.editState = this.stateList[stateIndex];

      await this.getCityList(this.cardData[0].state_code);
      const cityIndex = this.cityList.findIndex((item) => {
        return item.id == this.cardData[0].city_code;
      });
      this.editCity = this.cityList[cityIndex];

      this.editAddress = this.cardData[0].address;
      this.editPostalCode = this.cardData[0].postal_code;
    },

    confirmDeleteCard(id) {
      this.deleteCardId = id;
      this.openConfirmDeleteCardModal = true;
    },

    async handleDeleteCard(id) {
      store.commit("setIsLoading", true);
      await this.deleteUserCard(id);
      await this.getUserCardList();
      this.openConfirmDeleteCardModal = false;
      store.commit("setIsLoading", false);
    },

    async addCard() {
      this.cardNumber = this.cardNumber.split("-").join("");
      this.expiryDate = this.expiryDate.split(" ").join("");
      const data = {
        name_on_card: this.cardName,
        card_number: this.cardNumber,
        expiry_date: this.expiryDate,
        country_code: this.country,
        state_code: this.state,
        city_code: this.city,
        address: this.address,
        postal_code: this.postalCode,
        is_default: this.saveAsDefaultCard,
      };
      store.commit("setIsLoading", true);
      await this.addUserCard(data);
      await this.getUserCardList();
      store.commit("setIsLoading", false);
      this.openAddCreditCardModal = false;
      this.cardNumber = null;
      this.cardName = null;
      this.expiryDate = null;
      this.country = null;
      this.state = null;
      this.city = null;
      this.address = null;
      this.postalCode = null;
      this.userCardList.forEach((card) => {
        if (card.is_default) this.alreadyDefault = true;
      });
    },

    async editCard(id) {
      const data = {
        name_on_card: this.editCardName,
        card_number: this.editCardNumber,
        expiry_date: this.editExpiryDate,
        country_code:
          typeof this.editCountry === "object"
            ? this.editCountry.id
            : this.editCountry,
        state_code:
          typeof this.editState === "object"
            ? this.editState.id
            : this.editState,
        city_code:
          typeof this.editCity === "object" ? this.editCity.id : this.editCity,
        address: this.editAddress,
        postal_code: this.editPostalCode,
      };
      const payload = {
        id: id,
        data: data,
      };
      store.commit("setIsLoading", true);
      await this.updateCardDetails(payload);
      store.commit("setIsLoading", false);
      this.openEditCreditCardModal = false;
    },
  },
  async created() {
    await this.getUserCardList();
    await this.getCountryList();
    await this.getCityList();
    this.userCardList.forEach((card) => {
      if (card.is_default) this.alreadyDefault = true;
    });
  },
};
</script>